import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useVendor } from '../contexts/VendorContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Requires a signed-in user. A vendor whose store is still awaiting
 * approval is sent to /pending (they can still open their profile).
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isPendingVendor, loading } = useVendor();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  const allowedWhilePending = ['/pending', '/profile'];
  if (isPendingVendor && !allowedWhilePending.includes(location.pathname)) {
    return <Navigate to="/pending" replace />;
  }
  if (!isPendingVendor && location.pathname === '/pending') {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
